import styled from 'styled-components'

export const DefaultBranchIdContainer = styled.div`
  display: flex;
  align-items: center;
`
